             
export class CountryViewModel{
    countryCode: string;
    description: string;
    disabled: boolean;
}